import Icon from '../assets/pumpswap.webp';

export function PumpSwapIcon({ className = '' }: { className?: string }) {
    return <img className={'size-[28px] ' + className} src={Icon} alt='Pump Swap Icon' />;
}
